// src/services/callService.js
// ─────────────────────────────────────────────────────────────────
// All call API calls go through a single POST/PATCH endpoint:
//   POST  /calls/employee/:empId/:callKey   → create
//   PATCH /calls/employee/:empId/:callKey   → update
// Both map to the same backend logCall() which upserts the call
// AND appends a call_history entry automatically.
//
// History:
//   GET /employees/:empId/call-history            → all calls
//   GET /employees/:empId/call-history/:callKey   → one call
// ─────────────────────────────────────────────────────────────────
import api from './api';

const callService = {

  // ── Log a new call (first time for this callKey) ──────────────
  logDay10: (empId, data) =>
    api.post(`/calls/employee/${empId}/day10`, data).then(r => r.data),

  logDayN: (empId, callKey, data) =>
    api.post(`/calls/employee/${empId}/${callKey}`, data).then(r => r.data),

  // ── Update an existing call (re-logging) ──────────────────────
  // Backend still appends a history entry — every save is tracked.
  updateDay10: (empId, data) =>
    api.patch(`/calls/employee/${empId}/day10`, data).then(r => r.data),

  updateDayN: (empId, callKey, data) =>
    api.patch(`/calls/employee/${empId}/${callKey}`, data).then(r => r.data),

  // ── Unified helper — use when you don't care create vs update ─
  // Sends PATCH (backend upserts either way)
  save: (empId, callKey, data) =>
    api.patch(`/calls/employee/${empId}/${callKey}`, data).then(r => r.data),

  // ── Fetch call history ────────────────────────────────────────
  // Returns array of call_history rows newest-first
  getHistory: (empId, callKey) =>
    api.get(`/employees/${empId}/call-history/${callKey}`).then(r => r.data),

  getAllHistory: (empId) =>
    api.get(`/employees/${empId}/call-history`).then(r => r.data),

  // ── Fetch all calls for an employee ──────────────────────────
  getEmployeeCalls: (empId) =>
    api.get(`/calls/employee/${empId}`).then(r => r.data),
};

export default callService;